import React, { Component } from "react";

import {Box, Button} from "react-bulma-components";
import { Columns } from "react-bulma-components";
import { Form } from "react-bulma-components";
import { Icon } from "react-bulma-components";
import { Heading } from "react-bulma-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import useButtonSelect from "../../hooks/useButtonSelect";
import {formatDate} from "../../utils";
import axios from "axios";

class OffHireSection extends Component {
  render() {

    /*
        Change on change function of off_hire_mileage (New Mileage) to run above function and set return as off_hire_excess_mileage
        The onChange function also needs to call a function that calculates mileage excess cost
    */


    const onQuoteReceivedTick = e => {
      let today = new Date();
      let data = {[e.target.name]: e.target.checked}
      if(e.target.checked){
        data['date_of_quote_received'] = formatDate(today);
      }
      else{
        data['date_of_quote_received'] = '';
      }
      this.props.triggerChange(data);
    }

    const onDamageIndicated = (damage) => {
      let today = new Date();
      let data = {"has_damage": damage};
      data['date_of_damage_indicated'] = formatDate(today);
      this.props.triggerChange(data);
    }

    return (
      <Box>
        <Heading>Off Hire - To Be Completed on Vehicle Return</Heading>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Off Hire Date</Form.Label>
              <Form.Control>
                <Form.Input
                  type="date"
                  name="off_hire_date"
                  onChange={this.props.onChange}
                  value={this.props.rental.off_hire_date || ""}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
                <Form.Label>Off Hire Time</Form.Label>
                <Form.Input
                    type={"time"}
                    value={this.props.rental.off_hire_time}
                    onChange={this.props.onChange}
                    name={"off_hire_time"}
                />
            </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>New Mileage</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="off_hire_mileage"
                  onChange={this.props.onChange}
                  value={String(this.props.rental.off_hire_mileage)}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Mileage Excess (over allowance)</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="off_hire_excess_mileage"
                  onChange={this.props.onChange}
                  value={String(this.props.rental.off_hire_excess_mileage)}
                  disabled={!this.props.rental.off_hire_excess_mileage_override}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Mileage Excess Override</Form.Label>
              <Form.Control>
                <Form.Checkbox
                  name="off_hire_excess_mileage_override"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.off_hire_excess_mileage_override}
                />
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Label>Missing Fuel</Form.Label>
            <Form.Checkbox
                checked={this.props.rental.missing_fuel}
                onChange={this.props.onCheck}
                name={"missing_fuel"}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Missing Fuel Litres</Form.Label>
            <Form.Input
              value={this.props.rental.off_hire_fuel_litres}
              onChange={this.props.onChange}
              name={"off_hire_fuel_litres"}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Missing Fuel Charge</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="off_hire_missing_fuel"
                  onChange={this.props.onChange}
                  disabled={!this.props.rental.missing_fuel}
                  value={String(this.props.rental.off_hire_missing_fuel)}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Missing Ad Blue</Form.Label>
            <Form.Checkbox
                checked={this.props.rental.missing_ad_blue}
                onChange={this.props.onCheck}
                name={"missing_ad_blue"}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Ad Blue Charge</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="off_hire_ad_blue_charge"
                  onChange={this.props.onChange}
                  disabled={!this.props.rental.missing_ad_blue}
                  value={String(this.props.rental.off_hire_ad_blue_charge)}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Mileage Excess Cost</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="excess_mileage_charge"
                  onChange={this.props.onChange}
                  value={String(this.props.rental.excess_mileage_charge)}
                  disabled={!this.props.rental.excess_mileage_charge_override}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
              <Form.Control>
              <Form.Field>
                <Form.Label>Override</Form.Label>
                <Form.Checkbox
                  name="excess_mileage_charge_override"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.excess_mileage_charge_override}
                />
              </Form.Field>
            </Form.Control>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Field>
              <Form.Label>Off Hire Total Additional Charges</Form.Label>
              <Form.Control>
                <Form.Input
                  type="number"
                  name="off_hire_total_additional_charges"
                  value={String(
                    this.props.rental.off_hire_total_additional_charges
                  )}
                  onChange={this.props.onChange}
                  disabled={!this.props.rental.off_hire_total_additional_charges_override}
                />
                <Icon align={"left"} className={"small-icon"}>
                  <FontAwesomeIcon icon={faPoundSign}/>
                </Icon>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
          <Columns.Column>
              <Form.Control>
              <Form.Field>
                <Form.Label>Override</Form.Label>
                <Form.Checkbox
                  name="off_hire_total_additional_charges_override"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.off_hire_total_additional_charges_override}
                />
              </Form.Field>
            </Form.Control>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
              <Form.Field className="has-addons">
                <Form.Control>
                  <Form.Label>Our Insurance</Form.Label>
                  <Button
                    color={this.props.rental.off_hire_insurance_completed  === "NOT_REQUIRED" ?  "primary" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_insurance_completed", value: "NOT_REQUIRED"}})}
                  >
                    Not Required
                  </Button>
                  <Button
                    color={this.props.rental.off_hire_insurance_completed  === "NOT_DONE" ?  "danger" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_insurance_completed", value: "NOT_DONE"}})}
                  >
                    Not Done
                  </Button>
                  <Button
                    color={this.props.rental.off_hire_insurance_completed === "COMPLETE" ? "success" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_insurance_completed", value: "COMPLETE"}})}
                  >
                    Complete
                  </Button>
                </Form.Control>
              </Form.Field>
          </Columns.Column>
          <Columns.Column>
              <Form.Field className="has-addons">
                <Form.Control>
                  <Form.Label>Tracker Access</Form.Label>
                  <Button
                    color={this.props.rental.off_hire_tracker_completed  === "NOT_REQUIRED" ?  "primary" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_tracker_completed", value: "NOT_REQUIRED"}})}
                  >
                    Not Required
                  </Button>
                  <Button
                    color={this.props.rental.off_hire_tracker_completed  === "NOT_DONE" ?  "danger" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_tracker_completed", value: "NOT_DONE"}})}
                  >
                    Not Done
                  </Button>
                  <Button
                    color={this.props.rental.off_hire_tracker_completed === "COMPLETE" ? "success" : ""}
                    onClick={() => this.props.onChange({target: {name: "off_hire_tracker_completed", value: "COMPLETE"}})}
                  >
                    Complete
                  </Button>
                </Form.Control>
              </Form.Field>
          </Columns.Column>
          <Columns.Column>
              <Form.Field className="has-addons">
                <Form.Control>
                  <Form.Label>Key Assigned</Form.Label>
                  <Button
                    color={this.props.rental.key_assigned ? "" : "danger"}
                    onClick={() => this.props.onChange({target: {name: "key_assigned", value: false}})}
                  >
                    Unassigned
                  </Button>
                  <Button
                    color={this.props.rental.key_assigned ? "success" : ""}
                    onClick={() => this.props.onChange({target: {name: "key_assigned", value: true}})}
                  >
                    Assigned
                  </Button>
                </Form.Control>
              </Form.Field>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
              <Form.Field className="has-addons">
                <Form.Control>
                  <Form.Label>Has Damage</Form.Label>
                  <Button
                    color={this.props.rental.has_damage === "UNKNOWN"  ? "primary" : ""}
                    onClick={() => onDamageIndicated("UNKNOWN")}
                  >
                    Unknown
                  </Button>
                  <Button
                    color={this.props.rental.has_damage === "NO"  ? "success" : ""}
                    onClick={() => onDamageIndicated("NO")}
                  >
                    No
                  </Button>
                  <Button
                    color={this.props.rental.has_damage === "YES" ? "danger" : ""}
                    onClick={() => onDamageIndicated("YES")}
                  >
                    Yes
                  </Button>
                </Form.Control>
              </Form.Field>
          </Columns.Column>
          {this.props.rental.has_damage === "YES" ?
          <Columns.Column>
            <Form.Label>Damage Indicated Date</Form.Label>
            <Form.Input
              type={"date"}
              name={"date_of_damage_indicated"}
              value={this.props.rental.date_of_damage_indicated}
              onChange={this.props.onChange}
            />
          </Columns.Column> : <Columns.Column></Columns.Column>
          }
          <Columns.Column>
            <Columns>
              <Columns.Column>
                <p>{this.props.rental ? this.props.rental.linked_quote_count : 0} Quotes linked to this rental</p>
              </Columns.Column>
              <Columns.Column>
                <Form.Label invisible={true}>BLANK</Form.Label>
                <Button
                  color={"success"}
                  onClick={() => this.props.setQuoteModalOpen(true)}
                >
                  Create Quote +
                </Button>
              </Columns.Column>
              <Columns.Column>
                <Form.Label invisible={true}>BLANK</Form.Label>
                <Button
                  color={"success"}
                  onClick={() => this.props.onDuplicate()}
                >
                  Duplicate Quote
                </Button>
              </Columns.Column>
            </Columns>
          </Columns.Column>
        </Columns>
        {this.props.rental.has_damage === "YES" &&
          <Columns>
            <Columns.Column>
              <Form.Label>Quote Received</Form.Label>
              <Form.Checkbox
                name={"quote_received"}
                checked={this.props.rental.quote_received}
                onChange={onQuoteReceivedTick}
              />
            </Columns.Column>
            <Columns.Column>
              <Form.Label>Quote Received Date</Form.Label>
              <Form.Input
                type={"date"}
                name={"date_of_quote_received"}
                value={this.props.rental.date_of_quote_received}
                onChange={this.props.onChange}
              />
            </Columns.Column>
            <Columns.Column>
              <Form.Label>Quote Amount</Form.Label>
              <Form.Input
                name={"quote_amount"}
                value={this.props.rental.quote_amount}
                onChange={this.props.onChange}
              />
            </Columns.Column>
          </Columns>
        }
        <Columns>
          <Columns.Column>
              <Form.Control>
              <Form.Field>
                <Form.Label>Deposit Refunded</Form.Label>
                <Form.Checkbox
                  name="deposit_refunded"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.deposit_refunded}
                />
              </Form.Field>
            </Form.Control>
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Deposit Refund Amount</Form.Label>
            <Form.Input
                type={"number"}
                name={"deposit_refunded_amount"}
                value={this.props.rental.deposit_refunded_amount}
                onChange={(e) => this.props.onChange({target: {name: e.target.name, value: e.target.value}})}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Deposit Refund Date</Form.Label>
            <Form.Input
                type={"date"}
                name={"deposit_refunded_date"}
                value={this.props.rental.deposit_refunded_date}
                onChange={(e) => this.props.onChange({target: {name: e.target.name, value: e.target.value}})}
            />
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Form.Label>Off Hire Comments</Form.Label>
            <Form.Textarea
              value={this.props.rental.off_hire_comments}
              onChange={this.props.onChange}
              name={"off_hire_comments"}
            />
          </Columns.Column>
        </Columns>
      </Box>
    );
  }
}

export default OffHireSection;
